import { useMutation } from '@tanstack/react-query';
import type { AuditDependency } from '@repo/shared';
import { runAudit } from './api';

/**
 * TanStack useMutation wrapper around `runAudit`. The caller triggers the
 * audit via `mutate(dependencies)` and reads `data` / `isPending` / `error`
 * from the returned object.
 */
export function useAudit() {
  return useMutation({
    mutationFn: (dependencies: AuditDependency[]) => runAudit(dependencies),
  });
}
